import React from "react";
import { FaStar } from "react-icons/fa";

const Rating = ({ rate, showNumber = false }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex items-center space-x-1">
      {/* {showNumber && (
        <span className="mr-2 font-medium text-gray-700">{rate}/5</span>
      )} */}
      {stars.map((i) => (
        <FaStar
          key={i}
          className={`transition-colors duration-200 ${
            rate >= i ? "text-yellow-500" : "text-gray-300"
          }`}
          size={18}
        />
      ))}
    </div>
  );
};

export default Rating;
